export default __webpack_public_path__ + "static/media/services.d3fbc85d.jpg";